__turbopack_context__.v({
  "upsell": "UpsellSet-module-scss-module__P4pYoW__upsell",
  "upsell__body": "UpsellSet-module-scss-module__P4pYoW__upsell__body",
  "upsell__card": "UpsellSet-module-scss-module__P4pYoW__upsell__card",
  "upsell__card-content": "UpsellSet-module-scss-module__P4pYoW__upsell__card-content",
  "upsell__card-cta": "UpsellSet-module-scss-module__P4pYoW__upsell__card-cta",
  "upsell__card-image": "UpsellSet-module-scss-module__P4pYoW__upsell__card-image",
  "upsell__card-image-link": "UpsellSet-module-scss-module__P4pYoW__upsell__card-image-link",
  "upsell__card-name": "UpsellSet-module-scss-module__P4pYoW__upsell__card-name",
  "upsell__card-price": "UpsellSet-module-scss-module__P4pYoW__upsell__card-price",
  "upsell__card-rating": "UpsellSet-module-scss-module__P4pYoW__upsell__card-rating",
  "upsell__copy": "UpsellSet-module-scss-module__P4pYoW__upsell__copy",
  "upsell__headline": "UpsellSet-module-scss-module__P4pYoW__upsell__headline",
  "upsell__item": "UpsellSet-module-scss-module__P4pYoW__upsell__item",
  "upsell__item-name": "UpsellSet-module-scss-module__P4pYoW__upsell__item-name",
  "upsell__item-row": "UpsellSet-module-scss-module__P4pYoW__upsell__item-row",
  "upsell__list": "UpsellSet-module-scss-module__P4pYoW__upsell__list",
});
